import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useLocation, useNavigate, useOutletContext } from "react-router-dom";
import Form from "../../../components/form/Form";
import PageTitle from "../../../components/partials/PageTitle";
import {
  addStaffContactInfo,
  getAppStatus,
  resetStaffStatus,
} from "../../../redux/slice/staff/staffSlice";
import { isEmptyObject } from "../../../utils/validators/validators";
import useInputChange from "./../../../utils/hooks/useInputChange";
import PhoneInput from "react-phone-number-input";

const AddContactInformation = () => {
  const { user_permissions } = useSelector((state) => state.auth?.user);
  const { app_id, isLoading, isError, isSuccess, staff_records, pages } =
    useSelector((state) => state.staff);
  const { nextPage } = useOutletContext();

  const [error, setError] = useState({});
  const [staffInputData, setStaffInputData] = useState({
    email: "",
    contact_address: "",
    home_address: "",
    app_id: app_id,
  });
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [input, handleChange] = useInputChange(
    staffInputData,
    setStaffInputData,
    error,
    setError
  );
  const [phoneNumber, setPhoneNumber] = useState("");
  const [homeNumber, setHomeNumber] = useState("");
  const [borderColor, setBorderColor] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const handlePhoneNumberChange = (phone_no) => {
    if (!phone_no) {
      setBorderColor("#fa5c7c");
      setErrorMessage("Please enter phone number");
    } else {
      setBorderColor("");
      setErrorMessage("");
      setPhoneNumber(phone_no);
    }
    setStaffInputData({
      ...staffInputData,
      reporting_officer_number: phoneNumber,
    });
  };

  const handleHomeNumberChange = (value) => {
    setHomeNumber(value);
  };

  const handleSubmit = () => {
    if (isEmptyObject(error)) {
      if (!phoneNumber) {
        setBorderColor("#fa5c7c");
        setErrorMessage("Please enter phone number");
        return;
      }
      dispatch(
        addStaffContactInfo({
          ...staffInputData,
          phone_no: phoneNumber,
          home_number: homeNumber,
        })
      );
    }
  };

  const breadcrumb = {
    from: {
      title: "Add Staff",
      link: "/admin/add-staff",
    },
    current: {
      title: "contact information",
      link: null,
    },
  };

  useEffect(() => {
    !app_id
      ? navigate(-1)
      : nextPage &&
        navigate(nextPage, { state: { from: location }, replace: true });
  }, [pages]);

  useEffect(() => {
    if (isSuccess) {
      navigate("/admin/add-staff/education-info", {
        state: { from: location },
        replace: true,
      });
    }
    return () => {
      dispatch(resetStaffStatus());
    };
  }, [staff_records, isError, isSuccess, isLoading]);

  useEffect(() => {
    if (
      !user_permissions?.some(
        (permission) => permission.name === "staff module"
      ) ||
      !user_permissions?.some(
        (permission) => permission.name === "create staff"
      )
    ) {
      navigate("/admin/dashboard");
    }
  }, [navigate, user_permissions]);

  return (
    <>
      {/* page title */}
      <PageTitle title='Staff Creation' breadcrumb={breadcrumb} />
      {/* end page title */}

      {/* content */}
      <div className='row'>
        <div className='col-md-12'>
          <div className='card'>
            <div className='card-body'>
              <div className='row pb-2 mb-3 text-capitalize border-bottom'>
                <div className='col-md-12 d-flex justify-content-between align-items-center'>
                  <h4 className='header-title text-uppercase mb-0 text-primary'>
                    Contact Information
                  </h4>
                </div>
              </div>
              <Form
                setError={(e) => {
                  if (!phoneNumber) {
                    setBorderColor("#fa5c7c");
                    setErrorMessage("Please ");
                  }
                  setError(e);
                }}
                submitHandler={handleSubmit}
                values={staffInputData}
              >
                <div className='row g-'>
                  <div className='mb-0 col-md-4'>
                    <label
                      htmlFor='inputEmail4'
                      className='form-label d-flex align-baseline'
                    >
                      <span>Email Address</span>
                      {/* <span className='text-danger'>*</span> */}
                    </label>
                    <input
                      min_length={input.email && "3"}
                      validate={!input.email ? "false" : undefined}
                      textname='email address'
                      name='email'
                      onChange={handleChange}
                      value={input.email}
                      type='email'
                      className={`form-control ${error.email && "is-invalid"}`}
                      id='inputEmail4'
                      placeholder='Email Address'
                    />
                    {error.email && (
                      <span className='invalid-feedback'>{error.email}</span>
                    )}
                  </div>

                  <div className='mb-0 col-md-4'>
                    <label htmlFor='contact_address' className='form-label'>
                      Phone Number <span className='text-danger'>*</span>
                    </label>
                    <PhoneInput
                      placeholder='Enter phone number'
                      value={phoneNumber}
                      onChange={handlePhoneNumberChange}
                      onBlur={(e) => {
                        if (!e.target.value) {
                          setBorderColor("#fa5c7c");
                          setErrorMessage("Please ");
                        } else {
                          setBorderColor("");
                          setErrorMessage("");
                        }
                      }}
                      defaultCountry='NG'
                      className='form-control custom-phone-input'
                      style={{ borderColor: `${borderColor}` }}
                    />
                    {errorMessage && (
                      <span
                        className='text-danger'
                        style={{ fontSize: "12px" }}
                      >
                        {errorMessage}
                      </span>
                    )}
                  </div>

                  <div className='mb-0 col-md-4'>
                    <label htmlFor='inputEmail4' className='form-label'>
                      Home Phone
                    </label>
                    <PhoneInput
                      placeholder='Enter phone number'
                      value={homeNumber}
                      onChange={handleHomeNumberChange}
                      defaultCountry='NG'
                      className='form-control custom-phone-input'
                    />
                  </div>
                </div>

                <div className='row g-2'>
                  <div className='mb-3 mt-3'>
                    <label
                      htmlFor='inputEmail4'
                      className='form-label d-flex align-baseline'
                    >
                      <span>Contact Address</span>
                      <span className='text-danger'>*</span>
                    </label>
                    <textarea
                      min_length='5'
                      max_length='255'
                      textname='contact address'
                      name='contact_address'
                      value={input.contact_address}
                      onChange={handleChange}
                      id='contact_address'
                      className={`form-control ${
                        error.contact_address && "is-invalid"
                      }`}
                      rows='6'
                      placeholder='Enter address here'
                    ></textarea>
                    {error.contact_address && (
                      <span className='invalid-feedback'>
                        {error.contact_address}
                      </span>
                    )}
                  </div>
                </div>

                <div className='row g-2'>
                  <div className='mb-3'>
                    <label htmlFor='contact_address' className='form-label'>
                      Parmanent Address
                    </label>
                    <textarea
                      min_length={input.home_address && "5"}
                      validate={!input.home_address ? "false" : undefined}
                      textname='home address'
                      name='home_address'
                      value={input.home_address}
                      onChange={handleChange}
                      id='home_address'
                      className={`form-control ${
                        error.home_address && "is-invalid"
                      }`}
                      rows='6'
                      placeholder='Enter address here'
                    ></textarea>
                    {error.home_address && (
                      <span className='invalid-feedback'>
                        {error.home_address}
                      </span>
                    )}
                  </div>
                </div>

                <div className='float-end'>
                  <button
                    disabled={isLoading && true}
                    className='btn btn-primary w-10'
                  >
                    Proceed
                  </button>
                </div>
              </Form>
            </div>
          </div>
        </div>
      </div>
      {/* end content */}
    </>
  );
};

export default AddContactInformation;
